﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = (): string => {
    const uri = "api/sopnl/v1/user/settings";

    return uri;
};

const method = "PUT";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export interface PutUserSettingsRequest {
    PreferredUiCulture: string;
}

export interface PutUserSettingsProps extends api.ApiHookBaseProps<
    PutUserSettingsRequest,
    unknown,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function usePutUserSettings(
    props: PutUserSettingsProps
): [boolean, (data: PutUserSettingsRequest) => Promise<unknown>] {
    const { ...otherProps } = props;

    const apiParams: api.ApiHookProps<
        PutUserSettingsRequest,
        unknown,
        unknown
    > = {
        ...otherProps,
        uri: uri(),
        method: method,
    };

    const [loading, invoker] = api.useApi<
        PutUserSettingsRequest,
        unknown,
        unknown
    >(apiParams);
    return [
        loading,
        (data: PutUserSettingsRequest) => invoker(apiParams.uri, data),
    ];
}
